/*
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 *
 */

import {Outlet, useParams, useNavigate} from "react-router-dom";
import React, {useEffect} from 'react';
import Header from "./Header";
import Footer from "./Footer";

function Layout () {

    return (
        <div className="app">
            <Header/>
            <div className='main'>
                <Outlet />
            </div>
            <Footer/>
        </div>
    );

}

export default Layout;